import { util } from 'echarts/core';
import { type ThemeParser } from '../../../core/theme';
import { normalizeToArray } from '../../../util/utils';
import { judgeIsDynamicBar } from '../series/dynamicBar';

function parseDynamicHistogramGraphic(option: Parameters<ThemeParser>[0]) {
  option.graphic = util.merge(
    {
      elements: [
        {
          type: 'text',
          right: 60,
          bottom: 60,
          style: {
            font: `bolder 24px THSJinRongTi-Medium`,
            fill: 'rgba(50, 50, 50, 0.2)'
          },
          z: 100
        }
      ]
    },
    option.graphic || {},
    true
  );
}

export function graphicThemeParse(...args: Parameters<ThemeParser>): ReturnType<ThemeParser> {
  const option = args[0];
  const series = normalizeToArray(option.series);
  if (judgeIsDynamicBar(series)) {
    parseDynamicHistogramGraphic(option);
  }
}
